import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { STORAGE_KEYS } from 'constants/storageKeys';
import { tenantStorage } from 'utils/tenantStorage';
import { StoreAdminLoginRequest, StoreAdminSession } from 'types/admin';

const storeAdminAuthService = {
  getToken: (): string | null => tenantStorage.getItem(STORAGE_KEYS.ADMIN_TOKEN),

  persistSession: (session: StoreAdminSession) => {
    tenantStorage.setItem(STORAGE_KEYS.ADMIN_TOKEN, session.accessToken);
    if (session.displayName) {
      tenantStorage.setItem(STORAGE_KEYS.ADMIN_DISPLAY_NAME, session.displayName);
    }
  },

  clearSession: () => {
    tenantStorage.removeItem(STORAGE_KEYS.ADMIN_TOKEN);
    tenantStorage.removeItem(STORAGE_KEYS.ADMIN_DISPLAY_NAME);
  },

  login: async (payload: StoreAdminLoginRequest): Promise<StoreAdminSession> => {
    const { data } = await api.post(ENDPOINTS.ADMIN_AUTH_LOGIN, payload);
    const session: StoreAdminSession = {
      accessToken: data.accessToken ?? data.token,
      expiresAt: data.expiresAt,
      displayName: data.displayName,
    };
    storeAdminAuthService.persistSession(session);
    return session;
  },

  exchangeToken: async (erpAccessToken: string): Promise<StoreAdminSession> => {
    const { data } = await api.post(
      ENDPOINTS.ADMIN_AUTH_EXCHANGE,
      { erpAccessToken },
      { headers: { Authorization: `Bearer ${erpAccessToken}` } },
    );
    const session: StoreAdminSession = {
      accessToken: data.accessToken ?? data.token,
      expiresAt: data.expiresAt,
      displayName: data.displayName,
    };
    storeAdminAuthService.persistSession(session);
    return session;
  },

  acceptHandoffToken: (token: string, displayName?: string) => {
    storeAdminAuthService.persistSession({
      accessToken: token,
      expiresAt: new Date(Date.now() + 60 * 60 * 1000).toISOString(),
      displayName,
    });
  },
};

export default storeAdminAuthService;
